import { MeasurementConversion } from "../../../../CoStar/Api/EnterpriseSub2/Detail/index.js";
/** CoStar.Api.Maps.Hospitals.MeasurementConversion */
export { MeasurementConversion };
/** CoStar.Api.Maps.Hospitals.HospitalType */
export var HospitalType;
(function (HospitalType) {
    HospitalType[HospitalType["None"] = 0] = "None";
    HospitalType[HospitalType["AcuteCare"] = 1] = "AcuteCare";
    HospitalType[HospitalType["CriticalAccess"] = 2] = "CriticalAccess";
    HospitalType[HospitalType["Children"] = 3] = "Children";
    HospitalType[HospitalType["Psychiatric"] = 4] = "Psychiatric";
})(HospitalType || (HospitalType = {}));
/** CoStar.Api.Maps.Hospitals.HospitalOwnership */
export var HospitalOwnership;
(function (HospitalOwnership) {
    HospitalOwnership[HospitalOwnership["None"] = 0] = "None";
    HospitalOwnership[HospitalOwnership["PrivateVoluntaryNonprofit"] = 1] = "PrivateVoluntaryNonprofit";
    HospitalOwnership[HospitalOwnership["ChurchVoluntaryNonprofit"] = 2] = "ChurchVoluntaryNonprofit";
    HospitalOwnership[HospitalOwnership["OtherVoluntaryNonprofit"] = 3] = "OtherVoluntaryNonprofit";
    HospitalOwnership[HospitalOwnership["FederalGovernment"] = 4] = "FederalGovernment";
    HospitalOwnership[HospitalOwnership["StateGovernment"] = 5] = "StateGovernment";
    HospitalOwnership[HospitalOwnership["HospitalDistrictOrAuthority"] = 6] = "HospitalDistrictOrAuthority";
    HospitalOwnership[HospitalOwnership["LocalGovernment"] = 7] = "LocalGovernment";
    HospitalOwnership[HospitalOwnership["DepartmentOfDefense"] = 8] = "DepartmentOfDefense";
    HospitalOwnership[HospitalOwnership["Proprietary"] = 9] = "Proprietary";
    HospitalOwnership[HospitalOwnership["Physician"] = 10] = "Physician";
    HospitalOwnership[HospitalOwnership["Tribal"] = 11] = "Tribal";
})(HospitalOwnership || (HospitalOwnership = {}));
import { LengthMeasure } from "../../../../CoStar/Api/Brokers/ViewModels/index.js";
/** CoStar.Api.Maps.Hospitals.LengthMeasure */
export { LengthMeasure };
